(function () {
  if (window.__nvCollection) return;
  window.__nvCollection = true;

  function init(root) {
    (root || document).querySelectorAll('[data-nvl]').forEach(function (box) {
      if (box.__ready) return;
      box.__ready = true;

      // Filter + sort drawer.
      var drawer = box.querySelector('[data-nvl-drawer]');
      if (drawer) {
        box.querySelectorAll('[data-nvl-open]').forEach(function (button) {
          button.addEventListener('click', function () { drawer.showModal(); });
        });
        drawer.addEventListener('click', function (event) {
          if (event.target === drawer || event.target.closest('[data-nvl-close]')) drawer.close();
        });
        var form = drawer.querySelector('form');
        // Leave empty price boxes out of the URL.
        form.addEventListener('submit', function () {
          form.querySelectorAll('input[type="number"]').forEach(function (input) {
            if (input.value === '') input.disabled = true;
          });
        });
      }

      // Desktop sort menu: change reloads with the new order, filters kept.
      var sort = box.querySelector('[data-nvl-sort]');
      if (sort) {
        sort.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sort.value);
          url.searchParams.delete('page');
          window.location.assign(url.toString());
        });
      }

      // Description: two lines, with a toggle only when there is more to read.
      var desc = box.querySelector('[data-nvl-desc]');
      if (desc) {
        var text = desc.querySelector('.nvl-desc__text');
        var toggle = desc.querySelector('.nvl-desc__toggle');
        if (text.scrollHeight <= text.clientHeight + 2) {
          toggle.hidden = true;
        } else {
          toggle.addEventListener('click', function () {
            var open = desc.classList.toggle('is-open');
            toggle.textContent = open ? toggle.dataset.less : toggle.dataset.more;
            toggle.setAttribute('aria-expanded', String(open));
          });
        }
      }

      // "Show more" appends the next page in place; without JS it is a plain link.
      box.addEventListener('click', function (event) {
        var link = event.target.closest('[data-nvl-next]');
        if (!link) return;
        event.preventDefault();
        link.setAttribute('aria-busy', 'true');
        link.textContent = link.dataset.loading;
        fetch(link.href)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var grid = box.querySelector('[data-nvl-grid]');
            var incoming = doc.querySelector('[data-nvl-grid]');
            var cards = incoming ? Array.prototype.slice.call(incoming.children) : [];
            cards.forEach(function (card) { grid.appendChild(card); });
            var more = box.querySelector('[data-nvl-more]');
            var nextMore = doc.querySelector('[data-nvl-more]');
            if (nextMore) more.replaceWith(nextMore); else more.remove();
            var focusTarget = cards[0] && cards[0].querySelector('a.nvc-card__title');
            if (focusTarget) focusTarget.focus({ preventScroll: true });
          })
          .catch(function () { window.location.assign(link.href); });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
